import React from "react";
import { InfoCircle } from "../../../assets/icons/InfoCircle";

interface ImportantCardProps {
  title: string;
  subTitle: string;
  icon?: JSX.Element;
  spanText1: string;
  spanText2: string;
  spanText3: string;
  spanText4: string;
  spanText5: string;
}


const defaultProps: ImportantCardProps = {
  title: "",
  subTitle: "",
  icon: <></>,
  spanText1: "",
  spanText2: "",
  spanText3: "",
  spanText4: "",
  spanText5: "",
};

export const ImportantCard = ({
  title,
  subTitle,
  icon,
  spanText1,
  spanText2,
  spanText3,
  spanText4,
  spanText5,
}: ImportantCardProps = defaultProps): JSX.Element => {
  return (
    <div className="flex flex-col w-[full] lg:w-full xl:w-[full]  2xl:w-[full]  3xl:w-[full]  4xl:w-[full]  biglg:w-[full]   items-start gap-[12px] px-[20px] py-[16px] relative bg-[#fff4c6] rounded-[12px]">
      <div className="items-center gap-[8px] flex-[0_0_auto] inline-flex relative">
        <InfoCircle />
        <div className="relative w-fit mt-[-1.00px] font-medium text-black text-[24px] tracking-[0] leading-[normal]">
          Important
        </div>
      </div>
      <div className="flex-col items-start gap-[4px] flex-[0_0_auto] inline-flex relative">
        <div className="items-center gap-[8px] flex-[0_0_auto] inline-flex relative">
          <p className="relative w-fit mt-[-1.00px] [font-family:'Fellix-Medium',Helvetica] font-medium text-[#5a5a5a] text-[14px] tracking-[0] leading-[normal]">
            {title}
          </p>
          <div
            className="relative w-[116px] h-[17px] mt-[-0.5em]"
            style={{ whiteSpace: "nowrap" }}
          >
            <div className="items-center gap-[6px] inline-flex relative">
              <div
                className="relative w-fit mt-[-1.00px] [font-family:'Fellix-SemiBold',Helvetica] font-semibold text-[#044e97] text-[14px] tracking-[0.14px] leading-[normal]"
              >
                {subTitle}
              </div>
              {icon}
            </div>
          </div>
          <div className="relative w-fit mt-[-1.00px] [font-family:'Fellix-Medium',Helvetica] font-medium text-[#5a5a5a] text-[14px] tracking-[0] leading-[normal]">
            <span className="text-[#5a5a5a]">{spanText1}</span>
          </div>
        </div>
        <p className="relative w-[735px] [font-family:'Fellix-Medium',Helvetica] font-medium text-transparent text-[14px] tracking-[0] leading-[normal]">
          <span className="text-[#5a5a5a]"> {spanText2}</span>
          <span className="text-[#044e97]"> {spanText3}</span>
          <span className="text-[#5a5a5a]">&nbsp;</span>
          <span className="text-[#044e97]">{spanText4}</span>
          <span className="text-[#5a5a5a]"> {spanText5}</span>
        </p>
      </div>
    </div>
  );
};
